import type { FlexibleContentProps } from '@sola/schema/lib/schema.ts';

/**
 * Editor-facing placeholders for CMS organisms that need a minimum item count.
 *
 * Production code, despite the name of its previous home: this used to live in
 * `./storybook.tsx`, so every organism calling it dragged `@storybook/react`,
 * the mock fixtures, and `FlexibleSection` into the client bundle.
 */
const placeholderFills = {
  default: {
    title: 'Placeholder',
    icon: 'alert-circle',
  },
  stat: {
    title: '##',
  },
  link: {
    title: 'Placeholder',
    primaryCTA: {
      title: 'Placeholder Link',
      link: '#',
    },
  },
};

export const getPlaceholderItems = (
  items: FlexibleContentProps[] | undefined,
  minLength: number,
  type?: 'default' | 'stat' | 'link',
) => {
  if (!items || items.length < minLength) {
    return [
      ...(items || []),
      ...Array(minLength - (items?.length || 0)).fill({
        body: <p>at least {minLength} items required</p>,
        ...placeholderFills[type || 'default'],
      }),
    ];
  }
  return items;
};
